import React from "react";
import Form from "react-bootstrap/Form";

import "./style.css";

const TermsAndConditonText = ({ acceptCheckbox, setAgreeCheckbox }) => {
  const handleCheckboxChange = (e) => {
    setAgreeCheckbox(e.target.checked);
  };

  return (
    <div className="terms-condition-textbox px-4">
      <p>
        Please read these terms and conditions carefully before using website
        operated by FindxStorage.
      </p>

      <h5>Conditions of use</h5>
      <p>
        By using this website, you certify that you have read and reviewed this
        Agreement and that you agree to comply with its terms. If you do not
        want to be bound by the terms of this Agreement, you are advised to stop
        using the website accordingly. FindxStorage only grants use and access
        of this website, its products, and its services to those who have
        accepted its terms.
      </p>
      <h5>Privacy policy</h5>
      <p>
        Before you continue using our website, we advise you to read our privacy
        policy regarding our user data collection. It
        will help you better understand our practices.
      </p>
      <h5>Age restriction</h5>
      <p>
        You must be at least 18 (eighteen) years of age before you can use this
        website. By using this website, you warrant that you are at least 18
        years of age and you may legally adhere to this Agreement. FindxStorage assumes no responsibility for liabilities related to age
        misrepresentation.
      </p>
      <h5>Intellectual property</h5>
      <p>
        You agree that all materials, products, and services provided on this
        website are the property of FindxStorage, its affiliates, directors,
        officers, employees, agents, suppliers, or licensors including all
        copyrights, trade secrets, trademarks, patents, and other intellectual
        property. You also agree that you will not reproduce or redistribute the
        FindxStorage’s intellectual property in any way, including electronic,
        digital, or new trademark registrations. You grant FindxStorage a
        royalty-free and non-exclusive license to display, use, copy, transmit,
        and broadcast the content you upload and publish. For issues regarding
        intellectual property claims, you should contact the company in order to
        come to an agreement.
      </p>
      <h5>User accounts</h5>
      <p>
        As a user of this website, you may be asked to register with us and
        provide private information. You are responsible for ensuring the
        accuracy of this information, and you are responsible for maintaining
        the safety and security of your identifying information. You are also
        responsible for all activities that occur under your account or
        password. If you think there are any possible issues regarding the
        security of your account on the website, inform us immediately so we may
        address them accordingly. We reserve all rights to terminate accounts,
        edit or remove content and cancel orders at our sole discretion.
      </p>
      <h5>Applicable law</h5>
      <p>
        By using this website, you agree that the laws of the [your location],
        without regard to principles of conflict laws, will govern these terms
        and conditions, or any dispute of any sort that might come between
        FindxStorage and you, or its business partners and associates.
      </p>
      <h5>Disputes</h5>
      <p>
        Any dispute related in any way to your use of this website or to
        products you purchase from us shall be arbitrated by state or federal
        court [your location] and you consent to exclusive jurisdiction and
        venue of such courts.
      </p>
      <h5>Indemnification</h5>
      <p>
        You agree to indemnify FindxStorage and its affiliates and hold
        FindxStorage harmless against legal claims and demands that may arise
        from your use or misuse of our services. We reserve the right to select
        our own legal counsel.
      </p>
      <h5>Limitation on liability</h5>
      <p>
        FindxStorage is not liable for any damages that may occur to you as a
        result of your misuse of our website. FindxStorage reserves the right
        to edit, modify, and change this Agreement at any time. We shall let our
        users know of these changes through electronic mail. This Agreement is
        an understanding between FindxStorage and the user, and this
        supersedes and replaces all prior agreements regarding the use of this
        website.
      </p>
      <Form className="my-2">
        <Form.Check
          inline
          label="I agree to terms & conditions."
          checked={acceptCheckbox}
          onChange={handleCheckboxChange}
        />
      </Form>
    </div>
  );
};

export default TermsAndConditonText;
